import React from 'react';
import { useLocale } from '../../hooks/useLocale';
import { useStoreActions, useStoreState } from '../../store';
import { LanguageMenuScreen } from '../../store/languageMenu';
import { Browser } from '../../utils/browser';
import {
  HeaderAction,
  MobileDivider,
  MobileOptionLabel,
  MobileOptionRow,
  MobileSectionHeader,
  MobileSectionTitle,
  RadioIndicator,
} from './styles';

export const MobileRootScreen = () => {
  const locale = useLocale();
  const actions = useStoreActions((actions) => actions);
  const webVttSubtitles = useStoreState((state) => state.subtitles.webVttSubtitles);
  const activeSubtitle = useStoreState((state) => state.subtitles.activeSubtitle);
  const ignoreVideoEvents = useStoreState((state) => state.player.ignoreVideoEvents);
  const audioTracks = useStoreState((state) => state.player.audioTracks);
  const audioTrack = useStoreState((state) => state.player.audioTrack);

  function handleSubtitleChange(subtitle: TextTrack | null) {
    actions.subtitles.setActiveSubtitle(subtitle);
    actions.settings.setSubtitleTrack(subtitle);
  }

  function handleAudioTrackChange(track: AudioTrack) {
    if (ignoreVideoEvents) return;
    actions.player.setAudioTrack(track);
    actions.settings.setAudioTrack(track);
  }

  return (
    <>
      <MobileSectionHeader>
        <MobileSectionTitle>{locale.translations.LanguageOptions.Subtitles}</MobileSectionTitle>
        {webVttSubtitles.length > 0 && (
          <HeaderAction
            type="button"
            data-testid="videoPlayer_mobileOptionsLink"
            onClick={() => actions.languageMenu.navigateTo(LanguageMenuScreen.Options)}
          >
            {locale.translations.LanguageOptions.SubtitleOptions}
          </HeaderAction>
        )}
      </MobileSectionHeader>
      <MobileOptionRow onClick={() => handleSubtitleChange(null)}>
        <MobileOptionLabel active={activeSubtitle === null}>{locale.translations.General.Off}</MobileOptionLabel>
        <RadioIndicator active={activeSubtitle === null} />
      </MobileOptionRow>
      {webVttSubtitles.map((webVttSubtitle: TextTrack) => {
        const isActive = webVttSubtitle.label === activeSubtitle?.label;
        return (
          <MobileOptionRow key={`webvtt-${webVttSubtitle.id}`} onClick={() => handleSubtitleChange(webVttSubtitle)}>
            <MobileOptionLabel active={isActive}>{webVttSubtitle.label}</MobileOptionLabel>
            <RadioIndicator active={isActive} />
          </MobileOptionRow>
        );
      })}

      <MobileDivider />

      <MobileSectionHeader>
        <MobileSectionTitle>{locale.translations.LanguageOptions.Audio}</MobileSectionTitle>
      </MobileSectionHeader>
      {audioTracks
        .sort((trackA, trackB) => {
          if (Browser.isSafari || Browser.isIOS) return trackA.id > trackB.id ? 1 : -1;
          return 0;
        })
        .map((track) => {
          const isActive = audioTrack === track;
          return (
            <MobileOptionRow
              key={track.id}
              isDisabled={ignoreVideoEvents}
              onClick={() => handleAudioTrackChange(track)}
            >
              <MobileOptionLabel active={isActive}>{track.label}</MobileOptionLabel>
              <RadioIndicator active={isActive} />
            </MobileOptionRow>
          );
        })}
    </>
  );
};
